import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { StatusApprovedIcon, StatusAttentionIcon, WarningTriangleIcon } from '../icons';
import { CompilerStepState } from './CompilerStepsValidator';

const StepPanel: React.FunctionComponent<{
  label: string;
  name: string;
  description?: string;
  isSelected: boolean;
  stepState: CompilerStepState | undefined;
  path: string;
}> = ({ label, name, description, isSelected, stepState, path }) => {
  return (
    <Container to={path} $isSelected={isSelected}>
      {stepState === 'ok' && <StatusApprovedIcon style={{ position: 'absolute', top: '12px', right: '12px' }} />}
      {stepState === 'error' && <StatusAttentionIcon style={{ position: 'absolute', top: '12px', right: '12px' }} />}
      {stepState === 'warning' && <WarningTriangleIcon style={{ position: 'absolute', top: '12px', right: '12px' }} />}

      <StepLabel isSelected={isSelected}>{label}</StepLabel>
      <StepName isSelected={isSelected}>{name}</StepName>
      <StepDescription isSelected={isSelected}>{description || '\u00A0'}</StepDescription>
    </Container>
  );
};

const StepLabel = styled.div<{ isSelected?: boolean }>`
  ${(props) => props.theme.typography.headerCaptionRegular};
  color: ${(props) => (props.isSelected ? props.theme.colors.primaryBlack : props.theme.colors.primaryBlack70)};
`;

const StepName = styled.div<{ isSelected?: boolean }>`
  ${(props) => props.theme.typography.headerH4};
  padding-top: 10px;
  color: ${(props) => (props.isSelected ? props.theme.colors.primaryGreen : props.theme.colors.primaryBlack70)};
`;

const StepDescription = styled.div<{ isSelected?: boolean }>`
  margin-top: 4px;
  ${(props) => props.theme.typography.bodyInput};
  color: ${(props) => (props.isSelected ? props.theme.colors.primaryBlack : props.theme.colors.primaryBlack70)};
`;

const Container = styled(Link)<{ $isSelected?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
  padding: 16px;
  background-color: ${(props) => (props.$isSelected ? props.theme.colors.secondaryLightGreen30 : '#FAFAFB')};
  text-decoration: none;
  &:hover {
    background-color: ${(props) => (props.$isSelected ? props.theme.colors.primaryWhite : props.theme.colors.lightGray)};
  }
  position: relative;
`;

export default StepPanel;
